import { Component, OnInit } from '@angular/core';
import { OrdenMedicaSinAgendaEntity, OrdenMedicaSinAgendaBodyEntity, ServicioLaboratorioService } from 'src/app/services/servicio-laboratorio.service';
import { ActivatedRoute } from '@angular/router';
import { ImagesService } from 'src/app/services/utils/images.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reporte-ordenes-sin-agenda',
  templateUrl: './reporte-ordenes-sin-agenda.component.html',
  styleUrls: ['./reporte-ordenes-sin-agenda.component.css']
})
export class ReporteOrdenesSinAgendaComponent implements OnInit {

  loading: boolean = false;
  logo: string;
  user: string;
  fechaImpresion: Date;

  filtrosSeleccionados: OrdenMedicaSinAgendaEntity;
  detalle: OrdenMedicaSinAgendaBodyEntity[] = [];

  public objectOrden : OrdenMedicaSinAgendaEntity = {
    codigo : '',
    fechaInicial : 0,
    fechaFinal : 0,
    sede : -1,
    descripcionSede : ''
  }

  constructor( private activatedRoute: ActivatedRoute,
               private servicioImagenes: ImagesService,
               private servicioLaboratorio: ServicioLaboratorioService) { 
    this.activatedRoute.params.subscribe(params => {
      this.objectOrden.codigo = params['codigoBaseDatos'];
      this.objectOrden.sede = Number(params['sede']);
      this.user = params['user'];
    });
  }

  ngOnInit() {
    this.filtrosSeleccionados = this.objectOrden;
    this.getLogo(this.objectOrden.codigo);
    this.getData();
    this.fechaImpresion = new Date();
  }

  public onFiltrosCompletados(obj: OrdenMedicaSinAgendaEntity){
    this.loading = true;
    this.filtrosSeleccionados = obj;
    this.fechaImpresion = new Date();
    this.getLogo(obj.codigo);
    this.getData();
  }

  async getLogo(codigoBaseDatos: string){
    try{
      this.logo = '';
      let response = await this.servicioImagenes.getLogo(codigoBaseDatos);
      if(response != null){
        response.subscribe((data: any) => {
          this.logo = data.source;
        }, (err: HttpErrorResponse) => {
          this.logo = '';
        })
      }
    }catch(e){
      this.logo = '';
    }
  }

  async getData(){
    try{
      let response = await this.servicioLaboratorio.getOrdenesMedicaSinAgenda(this.filtrosSeleccionados);
      if(response != null){
        response.subscribe((data: OrdenMedicaSinAgendaBodyEntity[]) =>{
          this.detalle = data;
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          console.error('Error getData()', err);
          this.loading = false;
        });
      }
    }catch(e){
      console.error(e);
      this.loading = false;
    }
  }

}
